// import { Chart, LinearScale } from '@/chart'
import { Chart, LinearScale, CategoryScale } from 'chart.js';
import pallete from '@/assets/js/pallete'
import { BarWithErrorBarsController, BarWithErrorBar} from 'chartjs-chart-error-bars';

// import { pdfFontSize } from '../../assets/js/settings'
// import plugin from '@/chartjs-chart-error-bars'
// import { BarWithErrorBarsController, BarWithErrorBar } from 'chartjs-chart-error-bars'

/*
This exists as a placeholder. It will probably make more sense to redesign
BarChart.js to accept a vertical or horizontal parameter in the long term - this
is here for quick testing.
 */

export function parseData(data, labels){
    
    return data.map(dat => {
        const values = dat ? dat : labels.map(() => 0)
        return values.map(val => 100*val)
    })
}

function getDatasets(data, labels, params){
    let colors = pallete

    if (params.pallete){
        colors = [...params.pallete, ...pallete]
    }
    

    return parseData(data, labels, params).map((values, index) => {        
        return {
            data: values,
            backgroundColor: (params.multiColor && data.length===1) ? colors : colors[index]
        }
    })
}

function getOptions(maxValue){
    console.log(maxValue)
    let options = {
        indexAxis: 'y',
        scales: {
            x: {
                min: 0,
                max: 30,
                
                display: true,
                ticks: {
                    callback: function(value){
                        return `${value}`
                    }
                }
            }
        },
        aspectRatio: 1,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context){
                        let value = context.raw.x                   
                        return value
                    }
                }
            }

        }
    }

    // if (pdf) {
    //     options.animation = false
    //     options.responsive = false
    //     options.scales.y.ticks['font'] = {
    //         size: pdfFontSize
    //     }
    //     options.scales['x'] = {
    //         ticks: {
    //             font: {
    //                 size: pdfFontSize
    //             }
    //         }
    //     }
    // }

    return options
}

function getConfig(data, labels, params, maxValue=30){
    // Chart.register(BarWithErrorBarsController, BarWithErrorBar, LinearScale)
    labels = params.alt_states ? params.alt_states : labels
    //const plugin = {'chartjs-chart-error-bars'};
    
    return {
        type: BarWithErrorBarsController.id,
        data: {
            labels,
            datasets: getDatasets(data, labels, params)
        },
        options: getOptions(maxValue),
    }

}

Chart.register(BarWithErrorBarsController, BarWithErrorBar, LinearScale, CategoryScale);


export function initChart(ctx, labels, data, params={}, maxValue){
    return new Chart(ctx, getConfig(data, labels, params, maxValue))
}

export function pdfChart(ctx, labels, data, params={}){
    return new Chart(ctx, getConfig(data, labels, params, true))
}
